import { SubmissionTestingStatus } from "../sdk"

type testingStatusMap = {
  [key in SubmissionTestingStatus]: string
}

export const submissionTestingStatusMap: testingStatusMap = {
  FAILED: "Fallito",
  COMPLETED: "Completato",
  IN_PROGRESS: "In Corso"
}

type TestingStatusClasses = {
  [key in SubmissionTestingStatus]: "text-red-500" | "text-green-500" | "text-indigo-700"
}

export const submissionTestingClass: TestingStatusClasses = {
  FAILED: "text-red-500",
  COMPLETED: "text-green-500",
  IN_PROGRESS: "text-indigo-700"
}